/**
 *  유저 리스트 검색 키워드 타입
 */
export const USER_LIST_SEARCH_KEYWORD_TYPE = {
  /**
   *  구매자명(유저명)
   */
  USER_NAME: 0,
  /**
   *  핸드폰 번호
   */
  USER_PHONE: 1,
  /**
   *  구매자 ID
   */
  USER_ID: 2,
};

/**
 *  기간 검색 버튼 리스트
 */
export const USER_RANK_SEARCH_PERIOD_BUTTON_LIST = [
  {
    id: 0,
    name: '오늘',
    value: 0,
  },
  {
    id: 1,
    name: '1일',
    value: -1,
  },
  {
    id: 2,
    name: '7일',
    value: -7,
  },
  {
    id: 3,
    name: '14일',
    value: -14,
  },
  {
    id: 4,
    name: '30일',
    value: -30,
  },
];

/**
 *  유저 리스트 검색 키워드 타입 TEXT
 */
export const USER_LIST_SEARCH_KEYWORD_TYPE_TEXT = {
  /**
   *  구매자명(유저명)
   */
  [USER_LIST_SEARCH_KEYWORD_TYPE.USER_NAME]: '구매자명',
  /**
   *  핸드폰 번호
   */
  [USER_LIST_SEARCH_KEYWORD_TYPE.USER_PHONE]: '핸드폰 번호',
  /**
   *  구매자 ID
   */
  [USER_LIST_SEARCH_KEYWORD_TYPE.USER_ID]: '구매자 ID',
};

/**
 *  유저 리스트 검색 키워드 타입 SELECT LIST
 */
export const USER_LIST_SEARCH_KEYWORD_TYPE_SELECT_LIST = [
  {
    id: USER_LIST_SEARCH_KEYWORD_TYPE.USER_NAME,
    name: USER_LIST_SEARCH_KEYWORD_TYPE_TEXT[USER_LIST_SEARCH_KEYWORD_TYPE.USER_NAME],
  },
  {
    id: USER_LIST_SEARCH_KEYWORD_TYPE.USER_PHONE,
    name: USER_LIST_SEARCH_KEYWORD_TYPE_TEXT[USER_LIST_SEARCH_KEYWORD_TYPE.USER_PHONE],
  },
  {
    id: USER_LIST_SEARCH_KEYWORD_TYPE.USER_ID,
    name: USER_LIST_SEARCH_KEYWORD_TYPE_TEXT[USER_LIST_SEARCH_KEYWORD_TYPE.USER_ID],
  },
];

export const USER_LIST_SEARCH_PARAMS_MAP = {
  [USER_LIST_SEARCH_KEYWORD_TYPE.USER_NAME]: 'name',
  [USER_LIST_SEARCH_KEYWORD_TYPE.USER_PHONE]: 'cellPhone',
  [USER_LIST_SEARCH_KEYWORD_TYPE.USER_ID]: 'id',
};
